import { Slide } from "@jelly/lesson";

import { task as task03 } from "../../../../../task/course-04/lesson-09/task-03";

const task: Slide = {
  titleHtml:
    "A plane wave is exciting the membrane of a moving coil microphone and makes it vibrate<br>with a frequency of 1000 Hz and a maximum velocity of 1 mm/s. The membrane is attached to a coil that<br>has a length of 4 m immersed in a magnetic field of 0.8 T. Give the RMS value of the EMF.",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task03.id,
        },
      },
    },
  },
};

export default task;
